export const LEARNICS_EXTENSION_LABELS = {
  studentLink: 'Learnics',
  classroomPro: 'Classroom Pro',
  oneClick: 'LearnicsU',
}
